const DispMap = {
    gemelli: 'Policlinico Gemelli',
    columbus: 'Presidio Columbus',
    Entrambi: 'Entrambi'
};

export default DispMap;